var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-block d-sm-inline-block d-md-flex align-items-center" },
    [
      _vm.contractInfos.currentContract
        ? _c("ob1-capsule", {
            attrs: {
              label: _vm.contractLabel,
              "is-information": "",
              "data-cs-encrypt": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.contractInfos.contractInfosLink
        ? [
            _vm.contractListInfos
              ? [
                  _c("ob1-liens", {
                    staticClass: "d-inline-block my-1 my-md-0 text-nowrap",
                    attrs: {
                      "modal-id": "contracts-list-popin",
                      text: _vm.contractInfos.contractInfosLink
                        .contractsLinkLabel,
                      "with-arrow": true,
                      "is-mini": true,
                      "is-button": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("contract-selector-popin", {
                    attrs: {
                      id: "contracts-list-popin",
                      contracts: _vm.contractListInfos.contracts,
                      "contract-popin-dto":
                        _vm.contractListInfos.contractPageInfosDto,
                    },
                  }),
                ]
              : [
                  _c("ob1-liens", {
                    staticClass: "d-inline-block my-1 my-md-0 text-nowrap",
                    attrs: {
                      id: "contracts-link",
                      text: _vm.contractInfos.contractInfosLink
                        .contractsLinkLabel,
                      href: _vm.contractInfos.contractInfosLink.contractsLink,
                      "with-arrow": true,
                      "is-mini": true,
                    },
                  }),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }